export default {

  getElementById: function (object, id) {
    return object[id] || null;
  },

  mapToObject: function (map) {
    const obj = {};
    for (const [key, value] of map.entries()) {
      obj[key] = value instanceof Map ? this.mapToObject(value) : value;
    }
    return obj;
  },

  recursiveDeepCopy: function(o) {
    let newO,
      i;

    if (typeof o !== 'object') {
      return o;
    }
    if (!o) {
      return o;
    }

    if ('[object Array]' === Object.prototype.toString.apply(o)) {
      newO = [];
      for (i = 0; i < o.length; i += 1) {
        newO[i] = this.recursiveDeepCopy(o[i]);
      }
      return newO;
    }

    newO = {};
    for (i in o) {
      if (o.hasOwnProperty(i)) {
        newO[i] = this.recursiveDeepCopy(o[i]);
      }
    }
    return newO;
  }
}
